/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery'
], function($) {

	var ExpandedController = function(options) {
		this.widget = options.widget;
	};

	ExpandedController.prototype.toggle = function(/*toggle*/) {
		var $card = $('<div class="card">');
		this.widget.$el.parent().append($card);

		if(this.widget.getExpandViewContent) {
			this.widget.getExpandViewContent(this.data, $card);
		}

		return Promise.resolve();
	};

	return ExpandedController;
});
